export default __webpack_public_path__ + "static/media/higo_loader.8e93b2d9.gif";